import { render, staticRenderFns } from "./AboutUS.vue?vue&type=template&id=9031c4d6&scoped=true&"
import script from "./AboutUS.vue?vue&type=script&lang=js&"
export * from "./AboutUS.vue?vue&type=script&lang=js&"
import style0 from "./AboutUS.vue?vue&type=style&index=0&id=9031c4d6&prod&lang=scss&scoped=true&"
import style1 from "./AboutUS.vue?vue&type=style&index=1&id=9031c4d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9031c4d6",
  null
  
)

export default component.exports